// Colored platform glyphs from the graph page's own asset set (Figma node 345-46
// family) — shared by the node details panel and the Actors tab drill-down list.
import { ReactComponent as TelegramIcon } from './assets/telgram.svg';
import { ReactComponent as TwitterIcon } from './assets/twitter.svg';
import { ReactComponent as FacebookIcon } from './assets/facebook.svg';
import { ReactComponent as InstagramIcon } from './assets/instagram.svg';
import { ReactComponent as TikTokIcon } from './assets/tiktok.svg';
import { ReactComponent as YoutubeIcon } from './assets/youtube.svg';
import { ReactComponent as VkontakteIcon } from './assets/vkontakte.svg';
import { ReactComponent as LinkedinIcon } from './assets/linkedin.svg';
import { ReactComponent as ThreadsIcon } from './assets/threads.svg';
import { ReactComponent as WeiboIcon } from './assets/weibo.svg';
import { ReactComponent as DouyinIcon } from './assets/douyin.svg';
import { ReactComponent as ZhihuIcon } from './assets/zhihu.svg';
import { ReactComponent as HupuIcon } from './assets/hupu.svg';
import { ReactComponent as PincongIcon } from './assets/pincong.svg';
import { ReactComponent as MaxIcon } from './assets/max.svg';
import { ReactComponent as BlueSkyIcon } from './assets/blueSky.svg';
import { ReactComponent as WebIcon } from './assets/web.svg';
import { ReactComponent as RedditIcon } from './assets/reddit.svg';
import { ReactComponent as DarkWebIcon } from './assets/darkWeb.svg';

export const PLATFORM_ICONS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  TELEGRAM: TelegramIcon,
  TWITTER: TwitterIcon,
  FACEBOOK: FacebookIcon,
  INSTAGRAM: InstagramIcon,
  TIKTOK: TikTokIcon,
  YOUTUBE: YoutubeIcon,
  VK: VkontakteIcon,
  LINKEDIN: LinkedinIcon,
  THREADS: ThreadsIcon,
  WEIBO: WeiboIcon,
  DOUYIN: DouyinIcon,
  ZHIHU: ZhihuIcon,
  HUPU: HupuIcon,
  PINCONG: PincongIcon,
  MAX: MaxIcon,
  BLUESKY: BlueSkyIcon,
  WEB: WebIcon,
  DARKWEB: DarkWebIcon,
  REDDIT: RedditIcon,
};

export const FALLBACK_PLATFORM_ICON = WebIcon;
